"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Directions = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  className: "fill",
  clipRule: "evenodd",
  d: "M8.356 1.2a.5.5 0 00-.8 0L5.82 3.513a.5.5 0 00.4.8h.824v2.733H4.313v-.824a.5.5 0 00-.8-.4L1.2 7.557a.5.5 0 000 .8l2.313 1.735a.5.5 0 00.8-.4v-.823h2.732v2.734h-.824a.5.5 0 00-.4.8l1.735 2.314a.5.5 0 00.8 0l1.735-2.314a.5.5 0 00-.4-.8H8.87V8.87h2.734v.822a.5.5 0 00.8.4l2.313-1.735a.5.5 0 000-.8L12.403 5.82a.5.5 0 00-.8.4v.825H8.869V4.313h.822a.5.5 0 00.4-.8L8.356 1.2z",
  fill: "#ACB3BE"
}));
var _default = exports.default = Directions;